import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import AccommodationTextList from './AccommodationTextList'

export type AdditionalPolicyNote = string | { text: string; pinned: boolean }

type Props = {
  additionalPolicyNotes: Array<string>
  highlighted?: boolean
}

const getAdditionalPolicyNoteKey = (note: string, index: number) => {
  return `${note}-${index}`
}

function AccommodationAdditionalPolicyNotes({ additionalPolicyNotes, highlighted = false }: Props) {
  const intl = useIntl()

  if (highlighted) {
    return <>
      {additionalPolicyNotes.map((note, index) => <BodyText key={getAdditionalPolicyNoteKey(note, index)} variant="medium" weight="bold">{note}</BodyText>)}
    </>
  }

  if (!additionalPolicyNotes.length) return null

  const heading = intl.formatMessage({
    id: 'zLreiOlcFhPcjLsWPTKf',
    defaultMessage: 'Please note',
  })

  return (
    <>
      <BodyText variant="medium" weight="bold" as="h4">{heading}</BodyText>
      <AccommodationTextList items={additionalPolicyNotes} getKey={getAdditionalPolicyNoteKey} />
    </>
  )
}

export default AccommodationAdditionalPolicyNotes
